import { defineMessages } from 'react-intl';

export const countryFilterMessages = defineMessages({
  selectSupplier: {
    id: '+lYxAr',
    defaultMessage: 'Select Country',
    description: 'Label for country filter dropdown',
  },
  multipleSelected: {
    id: 'm/4ufW',
    defaultMessage: 'Multiple',
    description: 'Message for country filter dropdown',
  },
  filterHeader: {
    id: 'HzUGHY',
    defaultMessage: 'Country',
    description: 'Header for country filter dropdown',
  },
});
